<br><br>
<div class="login-box center">
    <div class="login-logo">
        <img class="logoimg" src="assets/img/logo.webp">
    </div>
    <!-- /.login-logo -->
    <div class="card">
      <div class="card-body login-card-body">
        <p class="login-box-msg">Change Password</p>
  
        <form action="javascript:void(0);">
            <div class="input-group mb-3">
                <input type="email" name="username" class="form-control" placeholder="Email" [(ngModel)]="user.email" readonly>
                <div class="input-group-append">
                <div class="input-group-text">
                    <span class="fas fa-envelope"></span>
                </div>
                </div>
            </div>
          <div class="input-group mb-3">
            <input type="password" name="password" class="form-control" placeholder="Enter New Password" [(ngModel)]="user.newPassword" >
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-unlock-alt"></span>
              </div>
            </div>
          </div>
          <div class="input-group mb-3">
            <input type="password" name="password" class="form-control" placeholder=" Confirm New Password" [(ngModel)]="user.confirmPassword">
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-unlock-alt"></span>
              </div>
            </div>
          </div>
          <div class="row">
          
            <!-- /.col-->
            <div class="col-12">
              <button type="submit" class="btn btn-primary btn-block" (click)="changePassword()">Save Password</button>
            </div>
            <!-- /.col -->
          </div>
        </form>
        <!-- /.social-auth-links -->
      </div>
      <!-- /.login-card-body -->


